import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div className="container my-5">
    <h1>Privacy Policy for OOklass</h1>
    <p><strong>Effective Date:</strong> 18-10-2023</p>

    <h2>Introduction</h2>
    <p>
      OOklass is dedicated to protecting the privacy of your personal information, specifically information related to students. This Privacy Policy outlines how we collect, use, and protect student data for the sole purpose of effective management. By using our website (<a href="https://www.ooklass.in">www.ooklass.in</a>) and services, you consent to the practices described in this Privacy Policy.
    </p>

    <h2>Information We Collect</h2>
    <ul>
      <li><strong>Student Information:</strong> We collect personal information provided by students, such as names, student identification numbers, academic records, contact details, and related data. This information is used exclusively for the management of student-related activities and services.</li>
      <li><strong>Website Usage Data:</strong> We collect data related to the use of our website, including interactions with website features, content, and pages. This information is anonymized and aggregated for analysis, trends, and improvements.</li>
    </ul>

    <h2>How We Use Student Information</h2>
    <p>
      We use student information solely for the following purposes:
    </p>
    <ul>
      <li>To facilitate student enrollment, course management, and academic support.</li>
      <li>To provide academic performance insights to students and parents.</li>
      <li>To manage financial matters, including fee tracking and financial records.</li>
      <li>To customize and generate academic reports for students.</li>
      <li>To offer personalized recommendations for student growth.</li>
    </ul>

    <h2>Sharing Student Information</h2>
    <p>
      We do not share, sell, or rent student information to third parties. We maintain strict confidentiality and do not disclose student data except as required by law or to trusted partners directly involved in providing our services.
    </p>

    <h2>Security</h2>
    <p>
      We are committed to maintaining the security and confidentiality of student information. We employ reasonable administrative, technical, and physical safeguards to protect against unauthorized access, disclosure, alteration, or destruction of data.
    </p>

    <h2>Your Choices</h2>
    <p>
      Students and their parents/guardians have the right to:
    </p>
    <ul>
      <li>Access, review, and update student information.</li>
      <li>Request the deletion of student information.</li>
      <li>Opt out of receiving communications related to academic performance or personalized recommendations.</li>
    </ul>

    <h2>Website Usage Data</h2>
    <p>
      We collect and analyze website usage data to understand and enhance the user experience. This data is used for trends, analytics, and improvements. We do not collect device-related information.
    </p>

    <h2>Children's Privacy</h2>
    <p>
      OOklass does not knowingly collect or store personal information from children under the age of 13 without parental consent. If you believe we have collected information from a child under 13 without consent, please contact us, and we will take appropriate action.
    </p>

    <h2>Changes to this Privacy Policy</h2>
    <p>
      We may update this Privacy Policy as needed. Any significant changes will be communicated by posting the updated Privacy Policy on our website.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have questions or concerns about this Privacy Policy, student information, or interactions with OOklass, please contact us at admin@ooklass.in.
    </p>
  </div>
  )
}



      